import ListIcon from "@redotech/redo-icons/list.svg";
import { ExistsFilterOperator } from "@redotech/redo-model/views/advanced-filters/exists-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import { AdvancedTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

export const PickSessionExistsFilter: AdvancedTableFilter = {
  type: AdvancedFilterType.EXISTS,
  data: {
    name: "pickSessionId",
    type: AdvancedFilterType.EXISTS,
    value: true,
    operator: ExistsFilterOperator.NOT_EXISTS,
  },
  Icon: ListIcon,
  boolDisplay: { falseDisplay: "not assigned", trueDisplay: "assigned" },
  displayName: "Pick session",
};
